import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { theme } from './styled/theme';
import GlobalStyle from './GlobalStyle';
import store from './store';
import * as Sentry from '@sentry/react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';

if (process.env.REACT_APP_SENTRY_ENV && process.env.REACT_APP_SENTRY_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://4b313c4ac10d41079b54de3d0562e59b@o409747.ingest.sentry.io/5981650',
    integrations: [Sentry.browserTracingIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
    environment: process.env.REACT_APP_SENTRY_ENV,
  });
}

const element = document.getElementById('root');
const root = createRoot(element!);

const RootApp = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <App />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
};

root.render(<RootApp />);

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', RootApp);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
